export default function () {
  return {
    auth: false, // 是否启用用户验证
    name: '',
    group: ''
  }
}
